export const config = {
  hint: '请输入',
  slug: `images${Math.round(Math.random() * 100)}`,
  span: 1,
  type: 'media',
  intro: '请选择要上传的文件',
  title: '上传附件资源',
  render: 'big',
  default: {},
  maxSize: 500,
  readonly: false,
  required: false,
  description: '备注显示区域：进行详细的解释说明。',
  allowedTypes: [],
  allowedAppImport: true,
  allowedWebImport: true,
  hiddenWhenCreate: false,
  uploadQuantities: 20,
  showType: 'show',
  fileTypeImg: false,
  fileTypeVideo: false,
  fileTypeDoc: false,
  fileTypeMap: [
    {
      type: 'fileTypeImg',
      label: '图片',
      typeList: ['.gif', '.png', '.jpg', '.jpeg', '.bmp'],
    },
    {
      type: 'fileTypeVideo',
      label: '视频',
      typeList: [
        '.mp4',
        '.m3u8',
        '.flv',
        '.f4v',
        '.webm',
        '.mov',
        '.m4v',
        '.3gp',
        '.avi',
        '.wmv',
      ],
    },
    {
      type: 'fileTypeAudio',
      label: '音频',
      typeList: ['.mp3', '.wma', '.wav', '.amr', '.m4a'],
    },
    {
      type: 'fileTypeDoc',
      label: '文档',
      typeList: [
        '.txt',
        '.pdf',
        '.doc',
        '.docx',
        '.xls',
        '.xlsx',
        '.ppt',
        '.pptx',
        '.rtf',
        '.hlp',
        '.wps',
      ],
    },
  ],
}
